<template>
  <v-container fluid>
    <v-loader v-if="isLoading" absolute />
    <h1 class="page-title font-weight-regular">
      Смена
    </h1>

    <v-row v-if="!isLoading">
      <v-col
        v-for="(item, i) in items"
        :key="i"
        sm="6"
        cols="12"
      >
        <span class="label">{{ item.groupName }}</span>
        <div
          v-for="(workspace, j) in item.workspaces"
          :key="j"
          class="staff"
        >
          <v-staff
            v-model="selectedItems[i][j]"
            :workspace="workspace"
            :group-id="item.groupId"
          />
        </div>
      </v-col>
    </v-row>

    <div @click="setDay" class="open-work-shift-section d-flex justify-center">
      <v-btn class="button-open" dark :ripple="false">
        Сохранить
      </v-btn>
    </div>
  </v-container>
</template>

<script>
  import { DateTime } from 'luxon'
  import { mapGetters } from 'vuex'
  import VStaff from '@/components/administrator/work-shift/staff/Staff'
  import VLoader from '@/components/loader/Loader'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'WorkShift',
    mixins: [mixinSnackbarMessage],
    components: {
      VStaff,
      VLoader,
    },
    data () {
      return {
        isLoading: false,
        currentDate: DateTime.local().toFormat('y-MM-d'),
        items: [],
        selectedItems: [],
        todayItems: [],
        timeout: null,
      }
    },
    computed: {
      ...mapGetters({
        localStorageBranch: 'branches/getLocalStorageBranch',
      }),
    },
    methods: {
      getWorkSchedulesScheme () {
        const id = this.localStorageBranch.id
        this.$store.dispatch('workSchedules/fetchWorkSchedulesScheme', id)
          .then(res => {
            if (res.status === 200) {
              this.items = res.data.data
              this.items.forEach((item, i) => {
                item.workspaces.forEach(workspace => {
                  const user = {
                    created_at: '2021-02-15T06:57:09.000000Z',
                    deleted_at: null,
                    email: '–',
                    first_name: '–',
                    id: null,
                    image: null,
                    last_name: null,
                    last_visit_at: null,
                    name: '–',
                    phone: '',
                    surname: '–',
                    updated_at: '2021-02-15T06:57:09.000000Z',
                  }
                  workspace.users.unshift(user)
                })
                this.selectedItems[i] = []
              })
              this.getTodayWorkSchedule()
            } else {
              this.isLoading = false
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
      getTodayWorkSchedule () {
        const payload = {
          limit: 100,
          date: this.currentDate,
        }
        this.$store.dispatch('workSchedules/fetchWorkSchedules', payload)
          .then(res => {
            const todayItems = res.data.items
            this.todayItems = res.data.items
            const selectedItems = JSON.parse(JSON.stringify(this.selectedItems))
            this.items.forEach((item, i) => {
              item.workspaces.forEach((workspace, j) => {
                todayItems.forEach(todayItem => {
                  if (workspace.workSpaceId === todayItem.workSpace.id) {
                    if (!selectedItems[i]) {
                      selectedItems[i] = []
                    }
                    if (!selectedItems[i][j]) {
                      selectedItems[i][j] = []
                    }
                    selectedItems[i][j].push({
                      itemId: todayItem.id,
                      id: null,
                      workSpaceId: todayItem.workSpace.id,
                      shiftTime: todayItem.shiftTime,
                    })
                    selectedItems[i][j].push({
                      itemId: todayItem.id,
                      id: todayItem.user.id,
                      workSpaceId: todayItem.workSpace.id,
                      shiftTime: todayItem.shiftTime,
                    })
                  }
                })
              })
            })
            this.selectedItems = JSON.parse(JSON.stringify(selectedItems))
            this.isLoading = false
          })
      },
      setDay () {
        const data = {
          date: this.currentDate,
          filialId: this.localStorageBranch.id,
          items: [],
        }
        // console.log(this.selectedItems)

        this.selectedItems.forEach(selectedItem => {
          // console.log(selectedItem)
          if (Array.isArray(selectedItem) && selectedItem.length) {
            selectedItem.forEach(item => {
              if (item) {
                data.items.push(...item)
              }
            })
          }
        })

        this.$store.dispatch('workSchedules/setWorkScheduleDay', data)
          .then(res => {
            if (res.status === 200) {
              this.showSuccessMessage('Изменения сохранены')
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
    created () {
      this.getWorkSchedulesScheme()
    },
  }
</script>

<style lang="less" scoped>
  .page-title {
    margin-bottom: 24px;
  }

  .label {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
  }

  .staff-section {
    margin-bottom: 24px;
  }

  .janitor-section {
    margin-bottom: 24px;
  }

  .courier-section {
    .button-add {
      margin-top: 24px;
      background-color: @color-primary !important;
      height: 60px;
      font-size: 18px;
      font-weight: 500;
      padding: 40px;
    }
  }

  .open-work-shift-section {
    margin-top: 24px;
    .button-open {
      background-color: @color-primary !important;
      height: 60px;
      font-size: 18px;
      font-weight: 500;
      padding: 40px;
    }
  }
</style>
